import React, { ImgHTMLAttributes } from 'react';
import { ExtraProps } from 'react-markdown';
import Image from 'utils/Image';

const ImageRenderer = ({ node, ...props }: ImgHTMLAttributes<HTMLImageElement> & ExtraProps) => {
  const { src, alt } = props;

  return (
    <Image
      alt={alt || ''}
      src={src!}
      {...props}
      // see https://github.com/vercel/next.js/discussions/18474#discussioncomment-5501724
      height={0}
      sizes="100vw"
      style={{ width: '100%', height: 'auto' }}
      width={0}
    />
  );
};

export default ImageRenderer;
